import { render, staticRenderFns } from "./AlreadyNominatedReviewers.vue?vue&type=template&id=f9bc1304&scoped=true&"
import script from "./AlreadyNominatedReviewers.vue?vue&type=script&lang=js&"
export * from "./AlreadyNominatedReviewers.vue?vue&type=script&lang=js&"
import style0 from "./AlreadyNominatedReviewers.vue?vue&type=style&index=0&id=f9bc1304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bc1304",
  null
  
)

export default component.exports